import AE from '../../../images/flags/ae.svg'
import AU from '../../../images/flags/au.svg'
import BE from '../../../images/flags/be.svg'
import BR from '../../../images/flags/br.svg'
import CA from '../../../images/flags/ca.svg'
import DE from '../../../images/flags/de.svg'
import ES from '../../../images/flags/es.svg'
import FR from '../../../images/flags/fr.svg'
import IN from '../../../images/flags/in.svg'
import IT from '../../../images/flags/it.svg'
import JP from '../../../images/flags/jp.svg'
import MX from '../../../images/flags/mx.svg'
import NL from '../../../images/flags/nl.svg'
import PL from '../../../images/flags/pl.svg'
import SA from '../../../images/flags/sa.svg'
import SE from '../../../images/flags/se.svg'
import SG from '../../../images/flags/sg.svg'
import TR from '../../../images/flags/tr.svg'
import UK from '../../../images/flags/uk.svg'
import US from '../../../images/flags/us.svg'
import AMAZON from '../../../images/icons/amazon.svg'
import ANNOUNCEMENT from '../../../images/icons/announcement.svg'
import ARROW_DOWN_LEFT from '../../../images/icons/arrow-down-left.svg'
import ARROW_RIGHT from '../../../images/icons/arrow-right.svg'
import ARROW_UP from '../../../images/icons/arrow-up.svg'
import ARROWS_SWITCH from '../../../images/icons/arrows-switch.svg'
import ARROWS_UP from '../../../images/icons/arrows-up.svg'
import ASK_COBALT_SPARKLE from '../../../images/icons/ask-cobalt-sparkle.svg'
import BARCODE from '../../../images/icons/barcode.svg'
import BELL from '../../../images/icons/bell.svg'
import BOLT from '../../../images/icons/bolt.svg'
import BOLTS from '../../../images/icons/bolts.svg'
import BOOKMARK_FILLED from '../../../images/icons/bookmark-filled.svg'
import BOOKMARK from '../../../images/icons/bookmark.svg'
import BRIEFCASE from '../../../images/icons/briefcase.svg'
import BRUSH from '../../../images/icons/brush.svg'
import CALENDAR_SIMPLE from '../../../images/icons/calendar-simple.svg'
import CALENDAR from '../../../images/icons/calendar.svg'
import CAMPAIGN from '../../../images/icons/campaign.svg'
import CHECK_CIRCLE from '../../../images/icons/check-circle.svg'
import CHECKMARK from '../../../images/icons/checkmark.svg'
import CHEVRON_DOWN_FILLED from '../../../images/icons/chevron-down-filled.svg'
import CHEVRON_DOWN from '../../../images/icons/chevron-down.svg'
import CLIENTS from '../../../images/icons/clients.svg'
import CLIPBOARD from '../../../images/icons/clipboard.svg'
import CLOCK_TICK from '../../../images/icons/clock-tick.svg'
import COLUMNS from '../../../images/icons/columns.svg'
import COMPARE from '../../../images/icons/compare.svg'
import COPY from '../../../images/icons/copy.svg'
import CUBE from '../../../images/icons/cube.svg'
import DATA_FLOW_EMPTY from '../../../images/icons/data-flow-empty.svg'
import DATA_FLOW from '../../../images/icons/data-flow.svg'
import DOLLAR from '../../../images/icons/dollar.svg'
import DOTS_GRID_VERTICAL from '../../../images/icons/dots-grid-vertical.svg'
import DOTS_GRID from '../../../images/icons/dots-grid.svg'
import DOTS_HORIZONTAL from '../../../images/icons/dots-horizontal.svg'
import DOWNLOAD from '../../../images/icons/download.svg'
import EDIT from '../../../images/icons/edit.svg'
import EXPAND from '../../../images/icons/expand.svg'
import FILE_DOWNLOAD from '../../../images/icons/file-download.svg'
import FILE_WITH_TEXT from '../../../images/icons/file-with-text.svg'
import FILE from '../../../images/icons/file.svg'
import FINGERPRINT from '../../../images/icons/fingerprint.svg'
import FLAG_SIMPLE from '../../../images/icons/flag-simple.svg'
import FOLD from '../../../images/icons/fold.svg'
import FOLDER from '../../../images/icons/folder.svg'
import GLOBE from '../../../images/icons/globe.svg'
import GRID from '../../../images/icons/grid.svg'
import HASH from '../../../images/icons/hash.svg'
import HELP_CIRCLE from '../../../images/icons/help-circle.svg'
import HOME from '../../../images/icons/home.svg'
import INFO_CIRCLE_FILLED from '../../../images/icons/info-circle-filled.svg'
import INFO_CIRCLE from '../../../images/icons/info-circle.svg'
import LAPTOP from '../../../images/icons/laptop.svg'
import LAYERS from '../../../images/icons/layers.svg'
import LINE_CHART_UP from '../../../images/icons/line-chart-up.svg'
import LINE_CHART from '../../../images/icons/line-chart.svg'
import LINK_EXTERNAL from '../../../images/icons/link-external.svg'
import LIST from '../../../images/icons/list.svg'
import LOADER from '../../../images/icons/loader.svg'
import LOCK from '../../../images/icons/lock.svg'
import LOG_IN from '../../../images/icons/log-in.svg'
import LOG_OUT from '../../../images/icons/log-out.svg'
import MINUS_CIRCLE from '../../../images/icons/minus-circle.svg'
import NAV_AD_ACCOUNTS from '../../../images/icons/nav-icons/nav-ad-accounts.svg'
import NAV_ADVERTISING_PRODUCTS from '../../../images/icons/nav-icons/nav-advertising-products.svg'
import NAV_AI_AGENTS from '../../../images/icons/nav-icons/nav-ai-agents.svg'
import NAV_AI_ARTIFACTS from '../../../images/icons/nav-icons/nav-ai-artifacts.svg'
import NAV_AUTOMATIONS from '../../../images/icons/nav-icons/nav-automations.svg'
import NAV_CAMPAIGNS from '../../../images/icons/nav-icons/nav-campaigns.svg'
import NAV_CATEGORY_PERFORMANCE from '../../../images/icons/nav-icons/nav-category-performance.svg'
import NAV_CHEVRON from '../../../images/icons/nav-icons/nav-chevron.svg'
import NAV_CURRENCY from '../../../images/icons/nav-icons/nav-currency.svg'
import NAV_CUSTOM_DASHBOARDS from '../../../images/icons/nav-icons/nav-custom-dashboards.svg'
import NAV_DSP from '../../../images/icons/nav-icons/nav-dsp.svg'
import NAV_HOME from '../../../images/icons/nav-icons/nav-home.svg'
import NAV_KEYWORD_LISTS from '../../../images/icons/nav-icons/nav-keyword-lists.svg'
import NAV_KEYWORD_RESEARCH from '../../../images/icons/nav-icons/nav-keyword-research.svg'
import NAV_LABELS from '../../../images/icons/nav-icons/nav-labels.svg'
import NAV_MARKET_ANALYSIS from '../../../images/icons/nav-icons/nav-market-analysis.svg'
import NAV_MARKET_SEGMENTS from '../../../images/icons/nav-icons/nav-market-segments.svg'
import NAV_MENU_COLLAPSE from '../../../images/icons/nav-icons/nav-menu-collapse.svg'
import NAV_MENU_EXPAND from '../../../images/icons/nav-icons/nav-menu-expand.svg'
import NAV_ORG from '../../../images/icons/nav-icons/nav-org.svg'
import NAV_PORTFOLIO from '../../../images/icons/nav-icons/nav-portfolio.svg'
import NAV_PRODUCT_CATALOG from '../../../images/icons/nav-icons/nav-product-catalog.svg'
import NAV_SELLER_COMPLIANCE from '../../../images/icons/nav-icons/nav-seller-compliance.svg'
import NAV_SETTINGS from '../../../images/icons/nav-icons/nav-settings.svg'
import NAV_SHARE_OF_VOICE from '../../../images/icons/nav-icons/nav-share-of-voice.svg'
import NAV_TARGETING from '../../../images/icons/nav-icons/nav-targeting.svg'
import NEWSPAPER from '../../../images/icons/newspaper.svg'
import PACKAGE from '../../../images/icons/package.svg'
import PEOPLE from '../../../images/icons/people.svg'
import PIE_CHART from '../../../images/icons/pie-chart.svg'
import PIN from '../../../images/icons/pin.svg'
import PLACEHOLDER from '../../../images/icons/placeholder.svg'
import PLUG from '../../../images/icons/plug.svg'
import PLUS_CIRCLE from '../../../images/icons/plus-circle.svg'
import PLUS from '../../../images/icons/plus.svg'
import QR_CODE from '../../../images/icons/qr-code.svg'
import QUESTION_CIRCLE from '../../../images/icons/question-circle.svg'
import QUOTATION from '../../../images/icons/quotation.svg'
import REVIEWS_STAR from '../../../images/icons/reviews-star.svg'
import SAVE from '../../../images/icons/save.svg'
import SEARCH_LIST from '../../../images/icons/search-list.svg'
import SEARCH_NAV from '../../../images/icons/search-nav.svg'
import SEARCH_SM from '../../../images/icons/search-sm.svg'
import SEARCH_VOLUME from '../../../images/icons/search-volume.svg'
import SEARCH from '../../../images/icons/search.svg'
import SELECT_CIRCLE from '../../../images/icons/select-circle.svg'
import SETTINGS from '../../../images/icons/settings.svg'
import SHOPPING_BAG from '../../../images/icons/shopping-bag.svg'
import SHOPPING_CART from '../../../images/icons/shopping-cart.svg'
import SHOPPING_CHART_OUTLINED from '../../../images/icons/shopping-chart-outlined.svg'
import SKU from '../../../images/icons/sku.svg'
import SLASH_CIRCLE from '../../../images/icons/slash-circle.svg'
import SLIDERS from '../../../images/icons/sliders.svg'
import SNOWFLAKE from '../../../images/icons/snowflake.svg'
import SPEEDOMETER from '../../../images/icons/speedometer.svg'
import STARS_TWINKLE from '../../../images/icons/stars-twinkle.svg'
import TABLE from '../../../images/icons/table.svg'
import TAG from '../../../images/icons/tag.svg'
import TARGET from '../../../images/icons/target.svg'
import TOGGLE from '../../../images/icons/toggle.svg'
import TRASH from '../../../images/icons/trash.svg'
import TREND_DOWN from '../../../images/icons/trend-down.svg'
import TREND_UP from '../../../images/icons/trend-up.svg'
import TV from '../../../images/icons/tv.svg'
import TYPE from '../../../images/icons/type.svg'
import UPLOAD from '../../../images/icons/upload.svg'
import USER_CHECK from '../../../images/icons/user-check.svg'
import USER_FILLED from '../../../images/icons/user-filled.svg'
import USER_OUTLINE from '../../../images/icons/user-outline.svg'
import USER_WITH_SHADOW from '../../../images/icons/user-with-shadow.svg'
import USER_X from '../../../images/icons/user-x.svg'

const FlagList = {
    /** Sort alphabetically */
    AE,
    AU,
    BE,
    BR,
    CA,
    DE,
    ES,
    FR,
    IN,
    IT,
    JP,
    MX,
    NL,
    PL,
    SA,
    SE,
    SG,
    TR,
    UK,
    US,
}

export const IconList = {
    /** Sort alphabetically */
    AMAZON,
    ANNOUNCEMENT,
    ARROW_DOWN_LEFT,
    ARROW_RIGHT,
    ARROW_UP,
    ARROWS_SWITCH,
    ARROWS_UP,
    ASK_COBALT_SPARKLE,
    BARCODE,
    BELL,
    BOLT,
    BOLTS,
    BOOKMARK,
    BOOKMARK_FILLED,
    BRIEFCASE,
    BRUSH,
    CALENDAR_SIMPLE,
    CALENDAR,
    CAMPAIGN,
    CHECK_CIRCLE,
    CHECKMARK,
    CHEVRON_DOWN,
    CHEVRON_DOWN_FILLED,
    CLIENTS,
    CLIPBOARD,
    CLOCK_TICK,
    COLUMNS,
    COMPARE,
    COPY,
    CUBE,
    DATA_FLOW,
    DATA_FLOW_EMPTY,
    DOLLAR,
    DOTS_GRID,
    DOTS_GRID_VERTICAL,
    DOTS_HORIZONTAL,
    DOWNLOAD,
    EDIT,
    EXPAND,
    FILE,
    FILE_DOWNLOAD,
    FILE_WITH_TEXT,
    FINGERPRINT,
    FLAG_SIMPLE,
    FOLD,
    FOLDER,
    GLOBE,
    GRID,
    HASH,
    HELP_CIRCLE,
    HOME,
    INFO_CIRCLE,
    INFO_CIRCLE_FILLED,
    LAPTOP,
    LAYERS,
    LINE_CHART,
    LINE_CHART_UP,
    LINK_EXTERNAL,
    LIST,
    LOADER,
    LOCK,
    LOG_IN,
    LOG_OUT,
    MINUS_CIRCLE,
    PACKAGE,
    PEOPLE,
    PIE_CHART,
    PIN,
    PLACEHOLDER,
    PLUG,
    PLUS,
    PLUS_CIRCLE,
    QR_CODE,
    QUESTION_CIRCLE,
    QUOTATION,
    REVIEWS_STAR,
    SAVE,
    SEARCH,
    SEARCH_LIST,
    SEARCH_NAV,
    SEARCH_SM,
    SEARCH_VOLUME,
    SELECT_CIRCLE,
    SETTINGS,
    SHOPPING_BAG,
    SHOPPING_CART,
    SHOPPING_CHART_OUTLINED,
    SKU,
    SLASH_CIRCLE,
    SLIDERS,
    SNOWFLAKE,
    SPEEDOMETER,
    STARS_TWINKLE,
    TABLE,
    TAG,
    TARGET,
    TOGGLE,
    TRASH,
    TREND_DOWN,
    TREND_UP,
    TV,
    TYPE,
    UPLOAD,
    USER_CHECK,
    USER_FILLED,
    USER_OUTLINE,
    USER_WITH_SHADOW,
    USER_X,
    NAV_AD_ACCOUNTS,
    NAV_ADVERTISING_PRODUCTS,
    NAV_AI_AGENTS,
    NAV_AI_ARTIFACTS,
    NAV_AUTOMATIONS,
    NAV_CAMPAIGNS,
    NAV_CATEGORY_PERFORMANCE,
    NAV_CHEVRON,
    NAV_CURRENCY,
    NAV_CUSTOM_DASHBOARDS,
    NAV_SELLER_COMPLIANCE,
    NAV_DSP,
    NAV_HOME,
    NAV_KEYWORD_LISTS,
    NAV_KEYWORD_RESEARCH,
    NAV_LABELS,
    NAV_MARKET_ANALYSIS,
    NAV_MARKET_SEGMENTS,
    NAV_MENU_EXPAND,
    NAV_MENU_COLLAPSE,
    NAV_ORG,
    NAV_PORTFOLIO,
    NAV_PRODUCT_CATALOG,
    NAV_SETTINGS,
    NAV_SHARE_OF_VOICE,
    NAV_TARGETING,
    NEWSPAPER,
    ...FlagList,
}

export type FlagListType = keyof typeof FlagList
export type IconListType = keyof typeof IconList
